import {
  initialState,
  Actions,
  State,
  GET_ALL_LICENSES,
  GET_ALL_LICENSES_SUCCESS,
  GET_ALL_LICENSES_ERROR,
  RESET_GET_ALL_LICENSES,
} from '../../types/license/get-all'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ALL_LICENSES:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case GET_ALL_LICENSES_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case GET_ALL_LICENSES_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_GET_ALL_LICENSES:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
